import { render, staticRenderFns } from "./ReceiptPaymentView.vue?vue&type=template&id=be95d220"
import script from "./ReceiptPaymentView.vue?vue&type=script&lang=js"
export * from "./ReceiptPaymentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports